import { Component, Inject } from '@angular/core';
import { TopUpCardComponent } from '../../widgets/top-up-card/top-up-card.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface TopupModalData {
  title?: any;
  description?: any;
}

@Component({
  selector: 'app-topup-modal',
  imports: [CommonModule, TranslateModule, TopUpCardComponent],
  templateUrl: './topup-modal.component.html',
  styleUrl: './topup-modal.component.scss'
})
export class TopupModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TopupModalData,
    private dialogRef: MatDialogRef<TopupModalData>,

  ) { }
  ngOnInit(): void {
    document.body.classList.add('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.removeAttribute('aria-hidden');
    }
  }

  ngOnDestroy(): void {
    document.body.classList.remove('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.setAttribute('aria-hidden', 'true');
    }
  }

  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }

  closeDialog(res: any): void {
    this.beforeClose();
    this.dialogRef.close(res);
  }
}
